/* eslint-disable max-len */
/* eslint no-confusing-arrow: ["error", {allowParens: true}] */

import styled, { css } from 'styled-components';
import { Button, Card } from '@zillow/constellation';

import MediumIllustrationHouse2x from 'app/shared/images/MediumIllustrationHouse@2x.png';

// vars
const THEME_VALIDATION = 'props => props.theme && props.theme.ns';
const propertyCardCTAContainerHeight = '86px';
const propertyCardCTAMarginBottom = '4px';

export const StyledCard = styled(Card)`
        /* override */
        border-bottom: none;
        box-shadow: none;

        ${props => props.theme &&
                props.theme.ns && css`
                        border: 1px solid ${props.theme.foundation.colors.gray200};
                        padding:
                            ${props.theme.ns().spacing.getSpacing(2)}
                            ${props.theme.ns().spacing.getSpacing(2)}
                            0
                            ${props.theme.ns().spacing.getSpacing(2)};
                `}
`;

export const StyledPhotoAddressContainer = styled.div`
    cursor: pointer;

    ${props => THEME_VALIDATION && css`
                margin-bottom: ${propertyCardCTAMarginBottom};
                box-sizing: border-box;
                box-shadow: 0 ${propertyCardCTAMarginBottom} 0 0 ${props.theme.foundation.colors.blue400}, 0 0 2px 0 rgba(0, 0, 0, 0.25);
        `}
`;

export const StyledPropertyPhotoContainer = styled.div`
        width: 100%;
        height: 200px;

        background-repeat: no-repeat;
        background-position: center center;
        background-size: ${props => (props.primaryPhotoUrl ? 'cover' : '160px')};
        background-image: url(${props => (props.primaryPhotoUrl ? props.primaryPhotoUrl : MediumIllustrationHouse2x)});

        ${props => THEME_VALIDATION && css`
                    background-color: ${props.primaryPhotoUrl ? '#888' : props.theme.foundation.colors.blue200};
            `}
`;

export const StyledPropertyCardCTAContainer = styled.div`
        display: flex;
        flex-direction: row;
        align-items: center;
        height: ${propertyCardCTAContainerHeight};

        ${props => THEME_VALIDATION && css`
            padding: ${props.theme.ns().spacing.getSpacing(2)};
        `}
`;

export const StyledAddressContainer = styled.div`
        display: flex;
        flex-direction: column;
        flex-grow: 2;
        margin-right: 10px;
        overflow: hidden;
        white-space: nowrap;

        > * {
                overflow: hidden;
                text-overflow: ellipsis;
        }
`;

export const StyledButton = styled(Button)`
        align-self: center;
        margin: 0 auto;
        /* makes button text centered */
        padding: 9px 16px 12px 16px;
        white-space: nowrap;
`;

export const StyledPropertyPanelContainer = styled.div`
        display: flex;
        flex-direction: column;
`;
